import { css } from "@emotion/react";
import { Theme } from "@mui/material";

export const menuContainerNodeStyles = {
  open: (open: boolean) => (theme: Theme) =>
    open
      ? css({
          [theme.breakpoints.up("sm")]: {
            background: theme.palette.action.selected,
          },
        })
      : undefined,
  text: css({
    fontWeight: 600,
  }),
};
